import { defineMessages } from "react-intl"

export default defineMessages({
  downloadApp: {
    defaultMessage: "DOWNLOAD {device} APP",
    id: "src.components.WebAppPortal.RegistrationSuccess.downloadApp",
  },
  successMessage: {
    defaultMessage: "Success! Your information was submitted for verification.",
    id: "src.components.WebAppPortal.RegistrationSuccess.successMessage",
  },
  verificationMessage: {
    defaultMessage: "Verification shouldn't take longer than 24 hours.",
    id: "src.components.WebAppPortal.RegistrationSuccess.verificationMessage",
  },
  confirmationMessage: {
    defaultMessage: "Watch for a confirmation in your inbox.",
    id: "src.components.WebAppPortal.RegistrationSuccess.confirmationMessage",
  },
})
